import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DiffViewerContainer = styled('div')({
  fontFamily: 'monospace',
  whiteSpace: 'pre-wrap',
});

export const DiffPart = styled('span', {
  shouldForwardProp: (prop) => !['added', 'removed'].includes(prop),
})(({ theme, added, removed }) => ({
  ...(added && { backgroundColor: alpha(theme.palette.success.light, 0.3) }),
  ...(removed && { backgroundColor: alpha(theme.palette.error.light, 0.3), textDecoration: 'line-through' }),
}));
